export enum EnquiryStatusEnum {
    None = 0,
    Draft = 1,
    EnquiryValidation = 2,
    Review = 3,
    Archived = 4,
    Withdrawn = 5,
}
